'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormGroup = require('./FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _AxisLabels = require('../Utility/AxisLabels');

var _AxisLabels2 = _interopRequireDefault(_AxisLabels);

var _Slider = require('rc-slider/lib/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

var _rcTooltip = require('rc-tooltip');

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

require('rc-slider/assets/index.css');

var _rcSlider = require('rc-slider');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // NPM


// CSS


var handle = function handle(props) {
  var value = props.value,
      dragging = props.dragging,
      index = props.index,
      restProps = _objectWithoutProperties(props, ['value', 'dragging', 'index']);

  return _react2.default.createElement(
    _rcTooltip2.default,
    {
      prefixCls: 'rc-slider-tooltip',
      overlay: value,
      visible: dragging,
      placement: 'top',
      align: {
        offset: [0, -5]
      },
      key: index
    },
    _react2.default.createElement(_rcSlider.Handle, _extends({ value: value }, restProps))
  );
};

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Slider.__proto__ || Object.getPrototypeOf(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.getClassName = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          className = _this$props.className;

      var baseClass = 'Slider-root ' + className;
      if (value === undefined) {
        baseClass += ' unanswered';
      }
      return baseClass;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Slider, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          value = _props.value,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          disabled = _props.disabled,
          name = _props.name,
          errors = _props.errors,
          sliderOptions = _props.options;


      return _react2.default.createElement(
        _FormGroup2.default,
        { className: this.getClassName(), text: text, errors: errors },
        _react2.default.createElement(
          'div',
          { className: 'Slider-input-wrapper' },
          _react2.default.createElement(_AxisLabels2.default, _extends({}, sliderOptions, { labels: sliderOptions.labels })),
          _react2.default.createElement(_Slider2.default, _extends({
            name: name,
            handle: handle,
            dots: true,
            disabled: disabled,
            value: value,
            defaultValue: defaultValue,
            onChange: onChange
          }, sliderOptions))
        )
      );
    }
  }]);

  return Slider;
}(_react.Component);

Slider.propTypes = _extends({}, _utils.genericPropTypes, {
  value: _propTypes2.default.number,
  defaultValue: _propTypes2.default.number.isRequired,
  options: _propTypes2.default.shape({
    min: _propTypes2.default.number,
    max: _propTypes2.default.number,
    step: _propTypes2.default.number
  })
});

Slider.defaultProps = _extends({}, _utils.genericDefaultProps, {
  defaultValue: 0,
  options: {
    min: 0,
    max: 10,
    step: 1
  }
});

exports.default = Slider;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Slider.js
// module id = 202
// module chunks = 0